/* global localize */
import './App.scss';

import React, { useEffect, useState } from 'react';
import { Switch, Route } from 'react-router-dom';
import Startpage from './pages/Startpage.jsx';
import Header from './components/Header.jsx';
import Questions from './pages/Questions';
import Result from './pages/Result';
import Infopage from './pages/Infopage';
import SurveyStart from './pages/SurveyStart';
import { SurveyContext } from './context/surveyContext';

function App() {
  const [survey, setSurvey] = useState(null);
  const [result, setResult] = useState({});
  const [questionList, setQuestionList] = useState([]);
  const [showActive, setShowActive] = useState(false);
  const [showActiveStart, setShowActiveStart] = useState(false);

  return (
    <SurveyContext.Provider
      value={{
        survey,
        setSurvey,
        result,
        setResult,
        questionList,
        setQuestionList,
        showActive,
        setShowActive,
        showActiveStart,
        setShowActiveStart,
      }}
    >
      <Header />
      <Switch>
        <Route path={`${localize.url}/resultat`} component={Result} />
        <Route path={`${localize.url}/fragor`} component={Questions} />
        <Route path={`${localize.url}/steg2`} component={Infopage} />
        <Route path={`${localize.url}/start`} component={SurveyStart} />
        <Route path={`${localize.url}/`} component={Startpage} />
      </Switch>
    </SurveyContext.Provider>
  );
}

export default App;
